export default __webpack_public_path__ + "static/media/reviews_icon.93a1731a.svg";